import React, { Suspense, lazy } from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import CircularSpinner from '../Common/CircularProgress';
import theme from 'theme';

const PREFIX = 'Layouts';

const classes = {
    root: `${PREFIX}-root`
};

const Root = styled('div')((
    {
        theme: Theme
    }
) => ({
    [`& .${classes.root}`]: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	}
}));

const ClientTemplateCardList = lazy(
	() => import('./ClientTemplate/ClientTemplateCardList'),
);

const StandardTemplateCardList = lazy(
	() => import('./StandardTemplate/StandardTemplateCardList'),
);

interface TabPanelProps {
	children?: React.ReactNode;
	index: any;
	value: any;
}

function TabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
        <Root
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}>
			{value === index && (
				<Box p={3}>
					<div>{children}</div>
				</Box>
			)}
		</Root>
    );
}

function a11yProps(index: any) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

export default function Layouts() {

	const [value, setValue] = React.useState(0);

	const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
		setValue(newValue);
	};

	return (
		<div className={classes.root} style={{margin:"15px"}}>
			<AppBar position="static" style={{backgroundColor:"#042630"}}>
				<Tabs
				TabIndicatorProps={{style: {background:'#e4e5e6'}}}
					value={value}
					onChange={handleChange}
          textColor='inherit'
					aria-label="simple tabs example">
					<Tab label="My Templates" {...a11yProps(0)} />
					<Tab label="Standard Templates" {...a11yProps(1)} />
					{/* <Tab label="Standard Templates" {...a11yProps(2)} /> */}
				</Tabs>
			</AppBar>
			<TabPanel value={value} index={0}>
				<Suspense
					fallback={
						<div>
							<CircularSpinner />
						</div>
					}>
					<ClientTemplateCardList />
				</Suspense>
			</TabPanel>
			<TabPanel value={value} index={1}>
				<Suspense
					fallback={
						<div>
							<CircularSpinner />
						</div>
					}>
					<StandardTemplateCardList />
				</Suspense>
			</TabPanel>
			{/* <TabPanel value={value} index={2}>
				<Suspense
					fallback={
						<div>
							<CircularSpinner />
						</div>
					}>
					<StandardTemplateCardList />
				</Suspense>
			</TabPanel> */}
		</div>
	);
}
